import React from 'react';
import type { BannerTone } from './types';

/**
 * Brand-asset glyphs (source: rounded_check/info/x.svg, warn_bold.svg). The glyph takes its colour from the
 * tone token and the cut-out from the page background (warn_bold draws its "!" black instead), so both follow the light/dark mirror — the
 * status colours swap between themes, and a fixed fill would keep one theme's value in the other.
 */
const KNOCKOUT = 'var(--color-background-primary)';

const TONE_COLOR: Record<BannerTone, string> = {
    info: 'text-info-100',
    success: 'text-success-100',
    warning: 'text-warning-100',
    danger: 'text-danger-100',
};

const GLYPH: Record<BannerTone, React.ReactNode> = {
    info: (
        <>
            <rect fill={KNOCKOUT} x="17" y="7" width="6" height="26" />
            <path fill="currentColor" d="M20,2C10.06,2,2,10.06,2,20s8.06,18,18,18,18-8.06,18-18S29.94,2,20,2ZM22,32h-4v-15h4v15ZM22,13h-4v-4h4v4Z" />
        </>
    ),
    success: (
        <>
            <circle fill={KNOCKOUT} cx="20.5" cy="19.5" r="13.5" />
            <path fill="currentColor" d="M20,2C10.06,2,2,10.06,2,20s8.06,18,18,18,18-8.06,18-18S29.94,2,20,2ZM19.07,30.1l-9.94-10.56,2.91-2.74,6.79,7.21,10.26-12.81,3.12,2.5-13.14,16.4Z" />
        </>
    ),
    warning: (
        <>
            <rect fill="#000" x="17" y="11" width="6" height="24" />
            <path fill="currentColor" d="M39.16,32.95L23.07,3.59c-1.33-2.42-4.8-2.42-6.13,0L.84,32.95c-1.28,2.33.41,5.18,3.07,5.18h32.19c2.66,0,4.34-2.85,3.07-5.18ZM22,34h-4v-4h4v4ZM22,26h-4v-14h4v14Z" />
        </>
    ),
    danger: (
        <>
            <ellipse fill={KNOCKOUT} cx="19.5" cy="20" rx="14.5" ry="14" />
            <path fill="currentColor" d="M20,2C10.06,2,2,10.06,2,20s8.06,18,18,18,18-8.06,18-18S29.94,2,20,2ZM30.41,27.59l-2.83,2.83-7.59-7.59-7.59,7.59-2.83-2.83,7.59-7.59-7.59-7.59,2.83-2.83,7.59,7.59,7.59-7.59,2.83,2.83-7.59,7.59,7.59,7.59Z" />
        </>
    ),
};

export const BannerIcon: React.FC<{ tone: BannerTone; size?: 'sm' | 'lg' }> = ({ tone, size = 'sm' }) => (
    <svg
        viewBox="0 0 40 40"
        className={`${size === 'lg' ? 'h-10 w-10' : 'h-5 w-5'} shrink-0 ${TONE_COLOR[tone]}`}
        aria-hidden="true"
        focusable="false"
    >
        {GLYPH[tone]}
    </svg>
);
